import { useBoolean } from '@chakra-ui/hooks'
import { useToast } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useAuth from '@hook/shared/use-auth'

import { parseReabTypeVeichule } from '@helper/grid/parametrization-curve'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange
} from '@helper/util/cryptoStorange'
import parametrizationReab from '@service/parametrization-reab'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableGridAction,
  ITableHeader,
  Pagination
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IParams,
  IParamsEdit,
  IReabTypeVeichuleProvider,
  ITooglesParams,
  IUpdateParams,
  IUpdateParamsDate,
  IUpdateParamsEdit
} from '@base/@types/providers/Parametrization/ReabTypeVeichuleProvider'
import reabTypeVeichuleHeader from '@base/variables/headers/parametrization/reab-type-veichule'

const ReabTypeVeichuleProvider: FC = ({ children }) => {
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useBoolean(false)
  const [fastQuery, _setFastQuery] = useState<string>('')
  const [query, setQuery] = useState('')
  const [filename, setFilename] = useState('PRM Tipo Veículo - Relatório')
  const [_selected, _setSelected] = useState<any>()
  const [fetching, _setFetching] = useState(false)
  const [_error] = useState<string | undefined>()
  const [loadingEdit] = useState(false)
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [historic, updateHistoric] = useImmer<any[]>([])
  const [loadingHistoric, setLoadingHistoric] = useState(false)
  const [companieId, setCompanieId] = useState('')

  const { companies: authCompanies } = useAuth()

  const [data, updateData] = useImmer<any[]>([])
  const [selected, setSelectedOne] = useState(0)

  const [hiddenColumns, _updateHiddenColumns] = useImmer<string[]>([])
  const [filterEdit] = useImmer({
    centers: [],
    products: []
  })

  const [tooglesTable, updateToogleParams] = useImmer({
    pendentes: true,
    aprovados: true,
    recusados: true
  })

  const handleToogleTable = ({ name, value }: ITooglesParams) => {
    updateToogleParams(draft => {
      draft[name] = value
    })
  }

  const dateNow = new Date()
  const dateEnd = dateNow.setDate(dateNow.getDate() - 30)

  const [paramsDates, updateDatesParams] = useImmer({
    dateInit: dayjs(dateEnd).format('YYYY-MM-DD'),
    dateEnd: dayjs(new Date()).format('YYYY-MM-DD')
  })

  const handleParamsDate = ({ name, value }: IUpdateParamsDate) => {
    updateDatesParams(draft => {
      draft[name] = value
    })
  }

  const [paramsEdit, updateEditParams] = useImmer<IParamsEdit>({
    id: 0,
    nome: '',
    custoFixo: 0,
    pesoMaximo: 0,
    empresaId: 0
  })

  const handleUpdateEditParams = useCallback(
    async ({ name, value }: IUpdateParamsEdit) => {
      updateEditParams(draft => {
        draft[name] = value
      })
    },
    [updateEditParams]
  )

  const getCenters = useCallback(async () => {}, [])

  const [params, updateParams] = useImmer<IParams>({
    lojasIds: [],
    mundoIds: [],
    categoriasCompactasIds: [],
    fornecedoresIds: [],
    produtosIds: [],
    statusIds: [],
    curvaAbc: [],
    curvaIgualZero: false,
    produtoSemFornecedor: false
  })

  const [headers, updateHeaders] = useImmer<ITableHeader[]>(
    reabTypeVeichuleHeader
  )
  const handleHeaderLocalStorange = useCallback(() => {
    if (!localStorage.getItem('reabTypeVeichuleHeader')) {
      encrypteHeaderStorange('reabTypeVeichuleHeader', headers)
    } else {
      localStorage.removeItem('reabTypeVeichuleHeader')
      encrypteHeaderStorange('reabTypeVeichuleHeader', headers)
    }
  }, [headers])

  const exportData = useCallback(async () => {}, [])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true
      }

      updateHeaders(newHeaders)
      handleHeaderLocalStorange()
    },
    [handleHeaderLocalStorange, headers, updateHeaders]
  )
  const handleStorange = useCallback(async () => {
    if (localStorage.getItem('reabTypeVeichuleHeader')) {
      const newHeader = decrypterHeaderStorange('reabTypeVeichuleHeader')
      newHeader[0].columns[0] = {
        id: newHeader[0].columns[0].id,
        name: newHeader[0].columns[0].name,
        show: newHeader[0].columns[0].show
      }
      updateHeaders(newHeader)
    }
  }, [updateHeaders])
  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams(draft => {
      if (name === 'curvaIgualZero') {
        draft[name] = Boolean(value)
      } else {
        draft[name] = value
      }
      if (name === 'produtoSemFornecedor') {
        draft[name] = Boolean(value)
      } else {
        draft[name] = value
      }
    })
  }

  const handlePageChange = useCallback(async (_page: number) => {
    setLoading(true)
  }, [])

  const getData = useCallback(
    async (id: any) => {
      setLoading(true)
      setCompanieId(id)

      // await getMaintence()

      encrypteHeaderStorange('reabTypeVeichuleHeader', headers)

      handleStorange()

      try {
        parametrizationReab
          .getParamsReabTypeOfVeichule(id)
          .then(({ data: { data, pagination } }) => {
            updateData(draft => {
              return draft.filter(item => item.status === 99).concat(data)
            })
            setCompanieId(id)

            updatePagination(pagination)
            setLoading(false)
          })
          .catch(() => {
            updateData([])
            setLoading(false)
          })
      } catch {
        setLoading(false)
      }
    },
    [headers, handleStorange, updateData, updatePagination]
  )

  const updateDataCurve = useCallback(async () => {
    setLoading(true)

    try {
      const { data: _res } =
        await parametrizationReab.putParamsReabTypeOfVeichule({
          id: paramsEdit.id,
          empresaId: companieId === '' ? authCompanies[0] : companieId,
          pesoMaximo: Number(paramsEdit.pesoMaximo),
          custoFixo: Number(paramsEdit.custoFixo),
          nome: paramsEdit.nome
        })
      toast({
        title: 'Sucesso.',
        description: 'Tipo de veículo editado com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
    } catch (error: any) {
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
      setLoading(false)
    }
    setSelectedOne(0)
    getData(companieId)
  }, [
    getData,
    companieId,
    paramsEdit.id,
    paramsEdit.pesoMaximo,
    paramsEdit.custoFixo,
    paramsEdit.nome,
    authCompanies,
    toast
  ])

  const deleteData = useCallback(async () => {
    setLoading(true)
    try {
      await parametrizationReab.deleteParamsReabTypeOfVeichule([
        Number(selected)
      ])

      toast({
        title: 'Sucesso.',
        description: 'Registro deletado com Sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
    } catch (error: any) {
      const message =
        error.response?.status === 400
          ? error.response?.data?.message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
      setLoading(false)
    }
    setSelectedOne(0)
    getData(companieId)
  }, [getData, companieId, selected, toast])

  const createData = useCallback(async () => {
    setLoading(true)
    parametrizationReab
      .postParamsReabTypeOfVeichule({
        empresaId: companieId === '' ? authCompanies[0] : companieId,
        pesoMaximo: Number(paramsEdit.pesoMaximo),
        custoFixo: Number(paramsEdit.custoFixo),
        nome: paramsEdit.nome
      })
      .then(() => {
        // Atualiza os dados após o sucesso
        getData(companieId)

        // Exibe o toast de sucesso
        toast({
          title: 'Sucesso.',
          description: 'Tipo de veículo cadastrado com Sucesso',
          status: 'success',
          duration: 2000,
          isClosable: true
        })
      })
      .catch((error: any) => {
        // Extrai e define a mensagem de erro
        const message =
          error.response?.status === 400
            ? error.response?.data?.message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'

        // Exibe o toast de aviso em caso de erro
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })

        // Atualiza o estado de loading em caso de erro
        setLoading(false)
      })

    setSelectedOne(0)
    // CreateData
  }, [
    getData,
    companieId,
    authCompanies,
    paramsEdit.pesoMaximo,
    paramsEdit.custoFixo,
    paramsEdit.nome,
    toast
  ])

  const filtersList = useMemo<ILayoutFilter[]>(() => {
    return []
  }, [])

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return [
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'parameterReabTypeVeichule',
            data,
            headers,
            parser: parseReabTypeVeichule
          }
        ]
      },
      {
        type: 'parametrizationReabTypeVeichuleUpload'
      },

      {
        type: 'reabTypeVeichuleHistoric',
        data: data,
        onUpdate: updateData
      }
    ]
  }, [data, headers, updateData])

  const handleEditParams = useCallback(
    async (index: any) => {
      const dataResponse = await data
      const idData = await dataResponse.filter(x => x.id === Number(index))
      if (idData.length > 0) {
        handleUpdateEditParams({
          name: 'id',
          value: idData[0].id
        })
        handleUpdateEditParams({
          name: 'empresaId',
          value: idData[0].empresaId
        })
        handleUpdateEditParams({
          name: 'nome',
          value: idData[0].nome
        })
        handleUpdateEditParams({
          name: 'custoFixo',
          value: idData[0].custoFixo
        })
        handleUpdateEditParams({
          name: 'pesoMaximo',
          value: idData[0].pesoMaximo
        })
      }
    },
    [handleUpdateEditParams, data]
  )

  const handleSelect = useCallback(
    async (index: any) => {
      const similarProduct = index['id-id']
      const newSelected = selected

      setSelectedOne(prev => (prev !== similarProduct ? similarProduct : 0))
      if (newSelected === similarProduct) {
        updateEditParams({
          id: 0,
          nome: '',
          custoFixo: 0,
          pesoMaximo: 0,
          empresaId: 0
        })
      } else {
        handleEditParams(index['id-id'])
      }
    },
    [setSelectedOne, handleEditParams, selected, updateEditParams]
  )

  const handleCompanieIdTypeOfVeichule = useCallback(
    async (companieId: any) => {
      setCompanieId(companieId.value)
      getData(companieId.value)
    },
    [getData]
  )
  const postUpload = useCallback(
    async (event: any) => {
      setLoading(true)

      parametrizationReab
        .uploadTypeOfVeichule({
          file: event.target.files[0],
          id: companieId
        })
        .then(() => {
          getData(companieId)
          toast({
            title: 'Sucesso',
            description: 'Parâmetros carregados com sucesso',
            status: 'success',
            duration: 2000,
            isClosable: true
          })
          setLoading(false)
        })
        .catch(response => {
          let htmlLines = ''
          for (let aux = 0; aux < response.response.data.data.length; aux++) {
            htmlLines += '<li>' + response.response.data.data[aux] + '</>'
          }
          Swal.fire({
            title: '<strong>Ops, houver um error</u></strong>',
            icon: 'error',
            html: 'Verificar os erros abaixo, ' + htmlLines,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false
          })
          setLoading(false)
        })
    },
    [companieId, getData, toast]
  )
  const getHistoric = useCallback(
    async (id: any) => {
      setLoadingHistoric(true)

      try {
        await parametrizationReab
          .getParamsReabTypeOfVeichuleHistoric(id)
          .then(({ data: { data } }) => {
            updateHistoric(data)
            setLoadingHistoric(false)
          })
      } catch (error: any) {
        const message =
          error.response?.status === 400
            ? error.response?.data?.message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })
        setLoadingHistoric(false)
      }
    },
    [updateHistoric, toast]
  )
  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'checkbox',
        icon: <AiOutlineBarChart />,
        onChange: handleSelect,
        selecteds: selected,
        isMulti: false
      }
    ]
  }, [selected, handleSelect])

  const clearParams = useCallback(async () => {
    if (selected === 0) {
      updateEditParams({
        id: 0,
        nome: '',
        custoFixo: 0,
        pesoMaximo: 0,
        empresaId: 0
      })
    }
  }, [selected, updateEditParams])

  return (
    <ReabTypeVeichuleContext.Provider
      value={{
        loading,
        loadingEdit,
        data: parseReabTypeVeichule(data),
        params,
        headers,
        fetching,
        actions,
        tableInteraction,
        clearParams,
        selected,
        filterEdit,
        paramsEdit,
        paramsDates,
        tooglesTable,
        filename,
        query,
        filters,
        hiddenColumns,
        handlePageChange,
        pagination,
        fastQuery,
        filtersList,
        toggleColumn,
        handleUpdateParams,
        handleSelect,
        getCenters,
        handleParamsDate,
        setQuery,
        getData,
        exportData,
        createData,
        handleUpdateEditParams,
        handleToogleTable,
        updateDataCurve,
        companieId,
        deleteData,
        setFilters,
        setFilename,
        postUpload,
        handleCompanieIdTypeOfVeichule,
        getHistoric,
        loadingHistoric,
        historic
      }}
    >
      {children}
    </ReabTypeVeichuleContext.Provider>
  )
}

export default ReabTypeVeichuleProvider
export const ReabTypeVeichuleContext = createContext<IReabTypeVeichuleProvider>(
  {} as IReabTypeVeichuleProvider
)
